import { type ComponentProps, memo } from 'react'

import View from './Button.view'

export type ControllerProps = ComponentProps<typeof View>

export const Controller = memo(function ButtonController(props: ControllerProps) {
  return <View {...props} />
})

Controller.displayName = 'Button_Controller'

export default Controller
